import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { FC } from 'react';

type Props = {
  columns: string[];
  templateColumns: string;
};

export const ListHeader: FC<Props> = ({ columns, templateColumns }) => (
  <Box
    m={0}
    pl="16px" // list-item の padding-left 分
    pr="16px" // list-item の スクロールバーの幅
    h="40px"
    w="100%"
    bgColor="primaryList.header.bgColor"
  >
    <Grid
      templateColumns={templateColumns}
      gap="10px"
      justifyItems="start"
      alignItems="center"
      h="100%"
    >
      {columns.map((column, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <GridItem key={index}>
          <Text color="inherit" fontSize="sm" noOfLines={1}>
            {column}
          </Text>
        </GridItem>
      ))}
    </Grid>
  </Box>
);
